
    export async function monaco_module() { 
        return import(
            /* webpackChunkName: "monaco" */
            /* webpackMode: "eager" */
            'monaco-editor/esm/vs/editor/editor.api'
        ); 
    }
